import {
  FaUser,
  FaEnvelope,
  FaBuilding,
  FaPhone,
  FaIdCard,
  FaFileAlt,
} from "react-icons/fa"

import { useEffect, useState } from "react"
import { getDatabase, ref, get } from "firebase/database"

const ProfileSection = ({ selectedUser = {} }) => {
  const db = getDatabase()

  const {
    username,
    name,
    email,
    company_name,
    phone,
    gstin,
    pan,
    type,
    firms = null,
    partners = null,
  } = selectedUser || {}

  const [fullFirms, setFullFirms] = useState({})
  const [fullPartners, setFullPartners] = useState({})

  useEffect(() => {
    const fetchData = async () => {
      // 🔴 reset old data FIRST (very important)
      setFullFirms({})
      setFullPartners({})

      // ❌ don’t run if no valid user
      if (!selectedUser || !selectedUser.uid) return

      try {
        // ===== FIRMS =====
        if (firms && Object.keys(firms).length > 0) {
          const firmIds = Object.keys(firms)

          const firmSnaps = await Promise.all(
            firmIds.map(fid =>
              get(ref(db, `profileDashboard/${fid}`))
            )
          )

          const firmsData = {}
          firmSnaps.forEach((snap, i) => {
            if (snap.exists()) {
              firmsData[firmIds[i]] = snap.val()
            }
          })

          setFullFirms(firmsData)
        }

        // ===== PARTNERS =====
        if (partners && Object.keys(partners).length > 0) {
          const partnerIds = Object.keys(partners)

          const partnerSnaps = await Promise.all(
            partnerIds.map(pid =>
              get(ref(db, `profileDashboard/${pid}`))
            )
          )

          const partnersData = {}
          partnerSnaps.forEach((snap, i) => {
            if (snap.exists()) {
              partnersData[partnerIds[i]] = snap.val()
            }
          })

          setFullPartners(partnersData)
        }

      } catch (err) {
        console.error("Error fetching data:", err)
      }
    }

    fetchData()
  }, [selectedUser?.uid]) // 🔥 ONLY when user changes

  const profileFields = [
    { label: "Name", value: username || name, icon: FaUser },
    { label: "Email", value: email, icon: FaEnvelope },
    { label: "Company Name", value: company_name, icon: FaBuilding },
    { label: "Phone Number", value: phone, icon: FaPhone },
    { label: "GSTIN Number", value: gstin, icon: FaIdCard },
    { label: "PAN Number", value: pan, icon: FaFileAlt },
  ]

  return (
    <div className="profile-tab">

      <div className="section-header">
        <FaUser className="section-icon" />
        <h2>User Profile</h2>
      </div>

      <div className="profile-grid">

        {/* ================= USER ================= */}
        <div className="profile-card">
          <span className="tag top-right">
            {(type || "main").toUpperCase()}
          </span>

          <div className="profile-details">
            {profileFields.map(({ label, value, icon: Icon }) => (
              <div className="profile-field" key={label}>
        <label>
          <Icon className="field-icon" />
          {label}:
        </label>
        <span>{value ?? "Not provided"}</span>
      </div>
            ))}
          </div>
        </div>

        {/* ================= FIRMS ================= */}
        {Object.keys(fullFirms).length > 0 && (
          <div className="profile-card">
            <div className="profile-details">
              {Object.entries(fullFirms).map(([fid, firm]) => (
                <div key={fid} className="profile-subcard">

                  <span className="tag top-right">
                    {(firm.type || "firm").toUpperCase()}
                  </span>

                  <div className="profile-field">
                    <label><FaBuilding /> Company:</label>
                    <span>{firm.company_name ?? "Not provided"}</span>
                  </div>

                  <div className="profile-field">
                    <label><FaPhone /> Phone:</label>
                    <span>{firm.phone ?? "Not provided"}</span>
                  </div>

                  <div className="profile-field">
                    <label><FaEnvelope /> Email:</label>
                    <span>{firm.email ?? "Not provided"}</span>
                  </div>

                  <div className="profile-field">
                    <label><FaIdCard /> GSTIN:</label>
                    <span>{firm.gstin ?? firm.gst ?? "Not provided"}</span>
                  </div>

                  <div className="profile-field">
                    <label><FaFileAlt /> PAN:</label>
                    <span>{firm.pan ?? "Not provided"}</span>
                  </div>

                  <hr />
                </div>
              ))}
            </div>
          </div>
        )}

        {/* ================= PARTNERS ================= */}
        {Object.keys(fullPartners).length > 0 && (
          <div className="profile-card">
            <span className="tag top-right">PARTNER</span>

            <div className="profile-details">
              {Object.entries(fullPartners).map(([pid, partner]) => (
                <div key={pid} className="profile-subcard">

                  <div className="profile-field">
                    <label><FaUser /> Name:</label>
                    <span>{partner.name || partner.username || "Not provided"}</span>
                  </div>

                  <div className="profile-field">
                    <label><FaPhone /> Phone:</label>
                    <span>{partner.phone ?? "Not provided"}</span>
                  </div>

                  <div className="profile-field">
                    <label><FaEnvelope /> Email:</label>
                    <span>{partner.email ?? "Not provided"}</span>
                  </div>

                  <hr />
                </div>
              ))}
            </div>
          </div>
        )}

      </div>
    </div>
  )
}

export default ProfileSection